module.exports = __webpack_public_path__ + "img/inspiration-6.5aa4320.jpg";